import React from "react";

import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { HorizontalNavBar } from "components/HorizontalNavBar/HorizontalNavBar";
import { RoleName } from "constants/index";
import { Routes } from "constants/routes";
import { useUserRoleSelector } from "store";
import { IRoleName } from "store/types";

// Contacts mirror the list endpoint's roles (Team Member, Admin, Team Viewer). Ungated — no account flag.
const CONTACTS_ALLOWED_ROLES: IRoleName[] = [RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer];

export const NavigationTabs = () => {
  const userRole = useUserRoleSelector();
  const showContactsTab = userRole?.name ? CONTACTS_ALLOWED_ROLES.includes(userRole.name) : false;

  return (
    <HorizontalNavBar
      tabs={[
        {
          value: "users",
          label: "Altius Users",
          icon: <PermIdentityOutlinedIcon />,
          to: Routes.users,
          matchRouts: [Routes.users]
        },
        {
          value: "contacts",
          label: "Contacts",
          icon: <LanguageOutlinedIcon />,
          to: Routes.contacts,
          matchRouts: [Routes.contacts],
          hidden: !showContactsTab
        }
        // {
        //   value: "teams",
        //   label: "Teams",
        //   icon: <PeopleAltOutlinedIcon />,
        //   to: Routes.teams,
        //   matchRouts: [Routes.teams]
        // },
        // {
        //   value: "investmentEntities",
        //   label: "Investment entities",
        //   to: Routes.investmentEntities,
        //   matchRouts: [Routes.investmentEntities]
        // }
      ]}
    />
  );
};
